import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import PricingSection from "./components/PricingSection";
import WhyChooseSection from "./components/WhyChooseSection";
import Footer from "./components/Footer";
import CursorTrail from "./components/CursorTrail";
import FloatingElements from "./components/FloatingElements";

const LandingPage = () => {
  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Animated cursor trail */}
      <CursorTrail />
      
      {/* Floating gradient elements */}
      <FloatingElements />
      
      {/* Ambient background gradient overlay */}
      <div className="fixed inset-0 pointer-events-none z-0">
        {/* Top gradient */}
        <div className="absolute top-0 left-0 right-0 h-[60vh] bg-gradient-to-b from-violet-900/20 via-transparent to-transparent" />
        {/* Bottom gradient */}
        <div className="absolute bottom-0 left-0 right-0 h-[40vh] bg-gradient-to-t from-blue-900/20 via-transparent to-transparent" />
        {/* Noise texture */}
        <div className="absolute inset-0 bg-noise opacity-[0.015]" />
      </div>
      
      <Header />
      <main className="relative z-10">
        <HeroSection />
        <PricingSection />
        <WhyChooseSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
